import react, { useEffect } from "react";
import { OUTRO_HINT_SCREEN_DURATION } from "../utils/constants";
import { useNavigate } from "react-router-dom";

export function Rights() {
  const navigate = useNavigate();
  useEffect(() => {
    let timeout: any;
    timeout = setTimeout(() => {
      navigate("/ending");
    }, OUTRO_HINT_SCREEN_DURATION);
    return () => {
      timeout && clearTimeout(timeout);
    };
  }, []);
  return (
    <section className="rights-container">
      <article className="content">
        <p>
          Adapted from Mid face modular matrix SA-JUV-230007|Jan 2023
          MDAD01230004 Adverse events should also be reported to Allergan
          Aesthetics at [productsurveillance_eame@abbvie.com]
        </p>
        <p>
          AE Reporting: To report any side effects(s) In the event of any
          comments on the material(s) presented, please contact The Saudi Food &
          Drug Authority (SFDA) on the unified number 19999.
        </p>
        <p>
          To report any side effects(s) Saudi Arabia: The National
          Pharmacovigilance Centre (NPC)- SFDA Call Center: 19999- E-mail:
          npc.drug@sfda.gov.sa website: https://ade.sfda.gov.sa
        </p>
        <p>SA-JUV-240132| October 2024</p>
      </article>
      <footer>
        <img src={`/assets/juvederm-white.png`} alt="medicine logo " />
      </footer>
    </section>
  );
}
